export default function Testimonials() {
  const recentReviews = [
    {
      date: "December 09, 2025",
      rating: 5,
      text: "It was a smooth and easy process! Jacob was fantastic to work with as well as the rest of the staff! I would highly recommend him!",
      author: "cmcmahon27"
    },
    {
      date: "November 24, 2025",
      rating: 5,
      text: "I purchased a C43 AMG from him, and the whole experience was excellent. He explained everything clearly from start to finish, and even after the purchase, he was always quick to answer any questions I had.",
      author: "Hank"
    },
    {
      date: "November 11, 2025",
      rating: 5,
      text: "At Zeigler Mercedes Benz of Hoffman Estates IL I was able to purchase the perfect new 2025 MB GLS450 from ample stock at a price lower than competing dealers and at an incredible low finance rate of 1.99%.",
      author: "nonotmiketoo"
    },
    {
      date: "October 19, 2025",
      rating: 5,
      text: "The dealership and their team did a fantastic job of instilling confidence for me to complete my purchase from out of state.",
      author: "Clesko"
    },
    {
      date: "October 08, 2025",
      rating: 5,
      text: "Jacob made the car buying process as smooth as possible! He knew all the answers to our questions and made it an overall great experience. Will definitely be reaching out to Jacob for our next vehicle.",
      author: "labeebahaddad"
    },
    {
      date: "September 19, 2025",
      rating: 5,
      text: "We came up from Indy and bought a new GLS, Jacob was awesome. He helped us with questions early on and then took great care of us at the dealership. He really made the experience smooth and painless.",
      author: "mark_mitchell23"
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-zinc-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What <span className="text-amber-400">Clients Say</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Real reviews from real clients who trusted me with their Mercedes purchase
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* DealerRater Widget */}
          <div className="bg-black rounded-lg p-8 flex flex-col items-center justify-center">
            <div className="text-center">
              <a 
                href="http://www.dealerrater.com/sales/Jacob-Kapolka-review-771496/" 
                title="Jacob Kapolka" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block cursor-pointer"
              >
                <img 
                  src="http://www.dealerrater.com/json/dealers/downloaddealeremployeereviewsseal?dealerId=16169&employeeId=771496" 
                  alt="Jacob Kapolka DealerRater Reviews" 
                  className="max-w-full h-auto"
                />
              </a>
              <div id="tracking" className="hidden">
                <img src="http://www.google-analytics.com/collect?v=1&tid=UA-87014-12&ds=web&cid=f3651cef-1f7f-4b3e-bd8a-15171c4e171c&t=pageview&dp=/reademployeereviewswidget-sm-rec/771496&z=639018394538818797" alt="" />
              </div>
            </div>
          </div>

          {/* Recent Reviews */}
          <div className="bg-black rounded-lg p-8 max-h-[500px] overflow-y-auto">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-star-fill text-amber-400 mr-2"></i>
              Recent Reviews
            </h3>
            <div className="space-y-6">
              {recentReviews.map((review, index) => (
                <div key={index} className="border-b border-zinc-800 pb-6 last:border-0 last:pb-0">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-1">
                      {[...Array(review.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <span className="text-gray-500 text-xs">{review.date}</span>
                  </div>
                  <p className="text-gray-300 text-sm mb-2 leading-relaxed">
                    {review.text}
                  </p>
                  <p className="text-gray-500 text-xs">— {review.author}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Referral Program CTA */}
        <div className="bg-gradient-to-r from-amber-400 to-amber-500 rounded-lg p-6 md:p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-black/5"></div>
          <div className="relative z-10">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-black/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
              <i className="ri-gift-line text-black text-3xl md:text-4xl"></i>
            </div>
            <h3 className="text-black text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4 px-2">
              Refer a Buyer. Earn a Bonus.
            </h3>
            <p className="text-black/80 text-base md:text-lg mb-6 md:mb-8 max-w-2xl mx-auto px-2">
              Know someone looking for their dream Mercedes? Refer them to me and earn a cash bonus when they purchase. It's my way of saying thank you for trusting me with your network.
            </p>
            <a 
              href="/referral-program"
              className="inline-block px-6 md:px-10 py-4 bg-black text-white font-semibold rounded-lg hover:bg-zinc-900 transition-all duration-300 hover:scale-105 cursor-pointer text-base md:text-lg text-center mx-auto max-w-xs md:max-w-none whitespace-normal md:whitespace-nowrap"
            >
              <i className="ri-arrow-right-line mr-2"></i>
              Learn About the Referral Program
            </a>
          </div>
        </div>
      </div>

      {/* DealerRater Script */}
      <script src="https://www.dealerrater.com/ncdn/s/25.20251209.1148/Scripts/Analysis/drt.js" async></script>
    </section>
  );
}
